export function trimInput(input: string) {
	return input.trim();
}
